import { css, styled } from '../../core/theme/styled';

export const AppWrapper = styled.div<{ isRedirectMode?: boolean }>`
  ${({ isRedirectMode }) =>
    isRedirectMode &&
    css`
      background: ${(props) => props.theme.configuration.pageBackgroundColor};
    `}
  color: ${(props) => props.theme.palette.black.main};
  height: 100%;
`;
